import { isEmpty } from "lodash";
import { getFromStorage, setToStorage } from "./Helper";

// sessionStorage key for the unified loads list (page, search, tab, filters)
export const LOAD_LIST_STORAGE_KEY = "supplierLoadModuleState";

// --- save / load ---

function getLoadTypeForTab(tab: any) {
    if ( tab === "outbound" ) {
        return "OutboundLoad";
    }
    if ( tab === "reexport" ) {
        return "ReexportLoad";
    }
    return "InboundLoad";
}

function getTabFromState(state: any) {
    if ( state.tab === "outbound" || state.tab === "reexport" || state.tab === "inbound" ) {
        return state.tab;
    }

    const loadTypes = state.filters && state.filters.load_types;
    if ( loadTypes && loadTypes[0] === "OutboundLoad" ) {
        return "outbound";
    }
    if ( loadTypes && loadTypes[0] === "ReexportLoad" ) {
        return "reexport";
    }

    return "inbound";
}

function getFiltersObject(filters: any) {
    if ( !filters || typeof filters !== "object" || Array.isArray(filters) ) {
        return {};
    }
    return filters;
}

// Make sure tab and filters.load_types always match before we save
export function prepareLoadListState(state: any) {
    const tab = getTabFromState(state);
    const loadType = getLoadTypeForTab(tab);

    return {
        ...state,
        tab,
        filters: {
            ...getFiltersObject(state.filters),
            load_types: [loadType],
        },
    };
}

export function saveLoadListState(state: any) {
    const prepared = prepareLoadListState(state);
    setToStorage(LOAD_LIST_STORAGE_KEY, JSON.stringify(prepared));
    return prepared;
}

export function loadLoadListState() {
    const raw = getFromStorage(LOAD_LIST_STORAGE_KEY);

    if ( isEmpty(raw) || typeof raw !== "string" ) {
        return {};
    }

    try {
        return JSON.parse(raw);
    } catch (e) {
        return {};
    }
}

// --- back navigation (used when detail page has ?back_to=loads) ---

export function navigateBackToList(navigate: any, backTo: any) {
    if ( backTo !== "loads" ) {
        navigate(`/${ backTo }`);
        return;
    }

    const saved = loadLoadListState();
    const tab = saved.tab || "inbound";

    navigate(`/loads?tab=${ tab }`);
}
